import { render, staticRenderFns } from "./AddExtraCostsModal.vue?vue&type=template&id=6896cab1"
import script from "./AddExtraCostsModal.vue?vue&type=script&lang=js"
export * from "./AddExtraCostsModal.vue?vue&type=script&lang=js"
import style0 from "./AddExtraCostsModal.vue?vue&type=style&index=0&id=6896cab1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports